import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Send, CheckCircle } from 'lucide-react';
import { useBranding } from '../contexts/BrandingContext';

const ForgotPassword = () => {
  const { branding } = useBranding();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.ok) {
        setSent(true);
      } else {
        setError(data.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError('Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <CheckCircle size={64} style={{ color: '#10b981' }} />
            <h1>Check Your Email</h1>
            <p>If an account exists with <strong>{email}</strong>, we've sent a password reset link.</p>
          </div>

          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '24px' }}>
              The link expires in 1 hour. Check your spam folder if you don't see it.
            </p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <ArrowLeft size={18} />
              Back to Login
            </Link>
          </div>

          {(!branding.isWhiteLabeled || branding.poweredByVisible) && (
            <div className={branding.isWhiteLabeled ? 'powered-by-footer' : 'login-footer'}>
              {branding.isWhiteLabeled ? 'Powered by Serverli' : <p>Powered by Serverli</p>}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo-wrapper">
            <img
              src={branding.brandLogoUrl || '/serverliccm-logo.png'}
              alt={`${branding.brandName} Logo`}
              className="login-logo-img"
            />
          </div>
          <h1>Forgot Password</h1>
          <p>Enter your email to receive a reset link</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">
              <Mail size={16} />
              Email Address
            </label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              autoFocus
              autoComplete="email"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary login-btn"
            disabled={loading}
          >
            {loading ? (
              <>Sending...</>
            ) : (
              <>
                <Send size={18} />
                Send Reset Link
              </>
            )}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <Link to="/login" style={{ color: '#10b981', textDecoration: 'none', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <ArrowLeft size={16} />
            Back to Login
          </Link>
        </div>

        {(!branding.isWhiteLabeled || branding.poweredByVisible) && (
          <div className={branding.isWhiteLabeled ? 'powered-by-footer' : 'login-footer'}>
            {branding.isWhiteLabeled ? 'Powered by Serverli' : <p>Powered by Serverli</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
